import type React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface SendingBadgeProps {
  className?: string;
}

export const SendingBadge: React.FC<SendingBadgeProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <span className={cn("text-xs text-blue-500", className)}>
      {t("common.sending")}
    </span>
  );
};
